module.exports = __webpack_public_path__ + "img/liverpool_oak_bfusa_list.f1a0d032.jpg";